import { useContext } from 'react';

import { PreviewHighlightContext } from '../../context/PreviewHighlightContext';

export const usePreviewHighlight = () => {
  return useContext(PreviewHighlightContext);
};
